import { type FC } from "react";
import { generatePath, useParams } from "react-router-dom";

import { cx } from "@emotion/css";
import { type ButtonType } from "@snapchat/snap-design-system";

import { AbsoluteRoute, type RouteParams } from "../../../core/routes";
import { useSelectedOrganizationContainer } from "../../../shared/hooks";
import { LinkStyled, linkButtonDefaultClassName, linkButtonPrimaryClassName } from "../../../shared/styles";

import { GoToMyLenses } from "./messages.generated";

interface ManageLensesButton {
    type?: ButtonType;
    className?: string;
    searchString?: string;
}

export const ManageLensesButton: FC<ManageLensesButton> = ({ type, className }) => {
    const { lensId = "" } = useParams<RouteParams[AbsoluteRoute.SUBMIT_LENS_CREATE_SUCCESS]>();
    const { orgId = "", lensFolderId = "" } = useSelectedOrganizationContainer();

    return (
        <LinkStyled
            to={generatePath(AbsoluteRoute.ORG_LENS_FOLDER_LENS, { lensId, orgId, lensFolderId })}
            className={cx(type === "primary" ? linkButtonPrimaryClassName : linkButtonDefaultClassName, className)}
        >
            <GoToMyLenses />
        </LinkStyled>
    );
};
